import React, { createContext, useContext, useMemo } from 'react'

const ContextCollaborators = createContext(null)

interface ProviderCollaboratorProps {
  children: React.ReactNode;
  initData?: Record<string, unknown>;
}

const ProviderCollaborator = ({ children, initData }: ProviderCollaboratorProps) => {
  const store = useMemo(() => ({
    ...initData,
  }), [initData])

  return (
    <ContextCollaborators.Provider value={store}>{children}</ContextCollaborators.Provider>
  )
}

const useProviderCollaborator = () => {
  const context = useContext(ContextCollaborators)
  if (context === undefined) {
    throw new Error('CollaboratorContext must be used within a Collaborator')
  }
  return context
}

export { ProviderCollaborator, useProviderCollaborator }